import { resolveApiBaseUrl } from '../utils/apiBase';
import { ensureCsrfCookie, xsrfHeaders } from './authApi';

const API = () => resolveApiBaseUrl();

async function jsonFetch(path, options = {}) {
  await ensureCsrfCookie();
  const isFormData = options.body instanceof FormData;
  const response = await fetch(`${API()}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
      ...(options.body && !isFormData ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Request failed (${response.status})`);
  }
  if (response.status === 204) return null;
  return response.json();
}

export async function listAdminFeeds() {
  return jsonFetch('/v1/admin/feeds');
}

export async function createAdminFeed(payload) {
  return jsonFetch('/v1/admin/feeds', { method: 'POST', body: JSON.stringify(payload) });
}

export async function updateAdminFeed(id, payload) {
  return jsonFetch(`/v1/admin/feeds/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
}

export async function enableAdminFeed(id) {
  return jsonFetch(`/v1/admin/feeds/${id}/enable`, { method: 'POST' });
}

export async function disableAdminFeed(id) {
  return jsonFetch(`/v1/admin/feeds/${id}/disable`, { method: 'POST' });
}

export async function softDeleteAdminFeed(id) {
  return jsonFetch(`/v1/admin/feeds/${id}`, { method: 'DELETE' });
}

export async function hardDeleteAdminFeed(id) {
  return jsonFetch(`/v1/admin/feeds/${id}/hard`, { method: 'DELETE' });
}

export async function importAdminFeedsCsv(file, { dryRun = true, updateExisting = false } = {}) {
  const form = new FormData();
  form.append('file', file);
  return jsonFetch(
    `/v1/admin/feeds/import-csv?dryRun=${dryRun}&updateExisting=${updateExisting}`,
    { method: 'POST', body: form },
  );
}

export async function validateAdminFeedUrl(url) {
  return jsonFetch('/v1/admin/feeds/validate', {
    method: 'POST',
    body: JSON.stringify({ url }),
  });
}
